import { faGift } from "@jewlr/pro-light-svg-icons/faGift"
import { useSelector } from "react-redux"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Shimmer from "components/ui/shimmer"
import { IS_NA } from "helpers/application"
import { showHolidayShippingInfoPDP } from "helpers/holiday"

const Promo = () => {
  const prefStore = useSelector((state) => state.wizardUI.prefStore)
  const wizardLoading = useSelector((state) => state.wizard.loading)
  const ship = useSelector((state) => state.wizard.shipping.main)
  const outOfStock = useSelector(
    (state) => state.wizard.header?.product_out_of_stock
  )
  const holidayDelivery = useSelector(
    (state) => state.wizard.shipping.main?.available_holiday_delivery
  )

  if (outOfStock) return null
  if (!showHolidayShippingInfoPDP() || holidayDelivery == false) {
    return null
  }
  if (
    wizardLoading ||
    !prefStore ||
    (showHolidayShippingInfoPDP() && holidayDelivery == undefined)
  ) {
    return (
      <Shimmer
        className="tablet:w-full tablet:mb-8 w-(--base-width)"
        style={{
          "--base-width": "150px",
          height: "22px",
        }}
      />
    )
  }

  let message = null

  if (holidayDelivery) {
    let dateMsg =
      ship.delivery_dates?.length > 0
        ? ship.delivery_dates[
            ship.delivery_dates.length === 2 && !IS_NA() ? 1 : 0
          ].date
        : ship.delivery_date_range?.length > 0
          ? ship.delivery_date_range[0]
          : ""

    if (dateMsg) {
      message = (
        <>
          <FontAwesomeIcon
            className="text-12 mr-4 align-text-bottom"
            icon={faGift}
          />
          Get it by {dateMsg} for {sl.config.guaranteed_holiday_alias}
        </>
      )
    }
  }

  if (!message) return null

  return (
    <div
      className="bg-primary tablet:mb-8 tablet:w-full flex w-fit items-center justify-center px-16 text-white"
      style={{ height: "22px" }}
    >
      <p className="text-12 leading-12 font-semibold">{message}</p>
    </div>
  )
}

export default Promo
